import React from 'react';
import LearningCard from '../components/LearningCard';

const RushHour = () => (
  <LearningCard
    testid="rushhour"
    title="Rush Hour"
    subtitle="Microlearning"
    support="Tijdens Rush Hour draait alles om timing, duidelijkheid en een vlotte guest experience. In deze korte microlearning ontdekken jullie hoe het event werkt, wanneer jullie aanbod actief is en hoe jullie gasten correct informeren. We overlopen ook de belangrijkste afspraken rond teambriefing, deurcommunicatie, signage en het duidelijk uitleggen van voorwaarden of uitzonderingen."
    buttons={[
      {
        label: 'Open de microlearning',
        href: 'https://app.qoldo.com/p/deb7eb04-9884-4203-bd21-caca47a6c601?t=993c86c7-6e0c-4424-b30f-2b75f990d2db',
        testid: 'btn-open-microlearning',
      },
    ]}
  />
);

export default RushHour;
